import React, { useState } from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import TextField       from '@mui/material/TextField';

const FilterAutocomplete = React.memo(function FilterAutocomplete({
  label,
  options = [],
  value,
  onChange,
  getOptionLabel    = (opt) => (opt && opt.label != null ? String(opt.label) : ''),
  isOptionEqualToValue,
  inputProps: extraInputProps,
  ...rest
}) {
  const [open, setOpen]           = useState(false);
  const [searchText, setSearchText] = useState('');

  // When closed → show the selected option's label as real (black) input text.
  // When open   → show only what the user has typed so far (starts blank).
  const inputValue = open ? searchText : (value ? getOptionLabel(value) : '');

  return (
    <MuiAutocomplete
      {...rest}
      options={options}
      value={value}
      open={open}
      onOpen={() => { setOpen(true); setSearchText(''); }}
      onClose={() => { setOpen(false); setSearchText(''); }}

      inputValue={inputValue}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setSearchText(newValue);
      }}

      onChange={(e, opt, reason) => {
        onChange(e, opt, reason);
        setSearchText('');
      }}

      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      disableClearable

      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          inputProps={{ ...params.inputProps, autoComplete: 'off', ...extraInputProps }}
        />
      )}
    />
  );
});

export default FilterAutocomplete;
